export default __webpack_public_path__ + "static/media/languge.18f0fc82.gif";